import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import * as Yup from 'yup';
import { Form, FormActions, FormInput, FormTextArea } from '../../../../components/form/index.js';
import { useStoreContext } from '../../../../contexts/stores/store.tsx';
import { Store } from '../../../../models/stores/store.ts';

const validationSchema = Yup.object().shape({
    name: Yup
        .string()
        .required('Name is required')
        .min(2, "Name is too short")
        .max(255, 'Name is too long'),
    description: Yup.string().nullable(),
});

const StoreBody = () => {
    const { id } = useParams(); // Get the 'id' from the route parameter
    const {
        isLoaded,
        store,
        insertStore,
        updateStore } = useStoreContext();
    const [localStore, setLocalStore] = useState<Store>(store);
    useEffect(() => {
        setLocalStore(store);
    }, [store])
    const [errors, setErrors] = useState<Record<string, string>>({});

    const handleInputChange = (e: any) => {
        const { id, value } = e.target;

        setLocalStore((prevData: Store) => ({
            ...prevData,
            [id]: value, // Update the corresponding field in state
        }));

        validationSchema
            .validateAt(id, { ...localStore, [id]: value })
            .then(() => setErrors((prev) => ({ ...prev, [id]: '' })))
            .catch((err) => setErrors((prev) => ({ ...prev, [id]: err.message })));
    };

    const handleSubmit = () => {
        validationSchema
            .validate(localStore, { abortEarly: false })
            .then(() => {
                setLocalStore(localStore);
                if (id === "create")
                    insertStore(localStore);
                else
                    updateStore(localStore);
            })
            .catch((err) => {
                const validationErrors: Record<string, string> = {};
                err.inner.forEach((error: Yup.ValidationError) => {
                    if (error.path) validationErrors[error.path] = error.message;
                });
                setErrors(validationErrors);
            });
    };

    if (!isLoaded) return;
    return (
        <Form>
            <FormInput
                entity={localStore}
                handleInputChange={handleInputChange}
                fieldName='name'
                label='Name'
                errors={errors} />
            <FormTextArea
                entity={localStore}
                handleInputChange={handleInputChange}
                fieldName='description'
                label='Description'
                errors={errors} />
            <FormActions
                mainAction={handleSubmit}
                mainActionText="Save"
                showCancelButton
            />
        </Form>
    );
};

export default StoreBody;